module.exports = __webpack_public_path__ + "static/assets/19161c89a6ca04006606ca3f4f91fdec.mp3";